<template>
  <div class="ssc-notification" style="text-align: left;" id="kyccontainer">
    <div style="padding:5px 10px;">
      <div style="font-weight: bold;">
        Kindly Verify the detail below and if there is no change
        kindly acknowledge the checkbox and submit.
        <br />If you want to update some details
        Kindly use edit button to modify and submit
        <button
          class="btn btn-success"
          style="font-weight: bold;padding: 5px 10px;cursor: pointer;position: absolute;
    right: 10px;margin-top: -20px;"
          v-if="isAllowed"
          @click="isEdit=true"
        >Edit &#9998;</button>
      </div>
      <hr />
      <div :class="isEdit ? '' : 'cur'">
        <div :class="isEdit ? '' : 'disableds'">
          <div style="font-weight: bold;">Basic Details:</div>
          <div style="font-size:14px;padding: 10px 5px;">
            {{technicalDocumentNumber? ' Doc Number: '+technicalDocumentNumber : ''}}
            <span
              style="padding: 20px 10px;"
              v-html="getTechStatus()"
            ></span>
          </div>
          <div
            v-if="technicalWorkflowRemarks && (technicalDocumentStatus == 'S' || technicalDocumentStatus == 'R')"
            style="font-size: 14px;font-weight: normal;padding-bottom:13px;"
          >WorkFlow Remarks: {{technicalWorkflowRemarks ? technicalWorkflowRemarks:''}}</div>
          <div :class="isTechnical ? '': 'disableds'">
            <div class="row">
              <div class="col-lg-3 col-md-6 col-12 item-c">
                {{isInternational ? 'Company Registration Number' : 'PAN Number:'}}
                <input
                  class="form-control"
                  type="text"
                  placeholder="Enter Value"
                  v-model="masterFormData.idCardValue"
                />
              </div>
              <div class="col-lg-4 col-md-6 col-12 item-c">
                Vendor Name:
                <input
                  class="form-control"
                  type="text"
                  placeholder="Vendor Name"
                  v-model="masterFormData.partnerName"
                />
              </div>
              <div class="col-lg-4 col-md-6 col-12">
                <FileUploader
                  class="text-left"
                  :id="'documentId'"
                  :heading="'Attach PAN Certificate*'"
                  @fileInputChange="getIdCardAttachment($event)"
                />
                <div class="col-10 mt-1 p-0 pt-1" v-if="masterFormData.idCardDocId">
                  <ul style="list-style-type:disc;">
                    <li>
                      <a
                        @click="showAttachFile(masterFormData.idCardDocId)"
                        href="#"
                      >{{getFileName(masterFormData.idCardDocId)}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div style="font-weight: bold;">Contact Details:</div>

            <div class="row">
              <div class="col-lg-3 col-md-6 col-12 item-c">
                Mobile Number:
                <span class="prefix">(+{{masterFormData.isdCode}})</span>
                <input
                  class="form-control has-prefix"
                  type="text"
                  placeholder="Mobile Number"
                  v-model="masterFormData.mobileNumber"
                />
              </div>
              <div class="col-lg-4 col-md-6 col-12 item-c">
                Email Id:
                <input
                  class="form-control"
                  type="text"
                  placeholder="Email Id"
                  v-model="masterFormData.email"
                />
              </div>

              <div class="col-lg-4 col-md-6 col-12">
                <FileUploader
                  class="text-left"
                  :id="'documentId'"
                  :heading="'Attach Vendor Letter head request*'"
                  @fileInputChange="getLetterHeadAttachment($event)"
                />
                <div class="col-10 mt-1 p-0 pt-1" v-if="masterFormData.letterHeadDocId">
                  <ul style="list-style-type:disc;">
                    <li>
                      <a
                        @click="showAttachFile(masterFormData.letterHeadDocId)"
                        href="#"
                      >{{getFileName(masterFormData.letterHeadDocId)}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div style="font-weight: bold;">Address Details:</div>
            <div class="row" style="padding: 10px 0px;">
              <div class="col-12">
                <div>Address line</div>
                <input
                  v-model="masterFormData.address.streetAddress"
                  class="form-control"
                  maxlength="200"
                  placeholder="Minimum 10 characters"
                />
              </div>
              <div class="col-3">
                <div>Country</div>
                <select
                  v-model="masterFormData.address.countryCode"
                  class="form-control"
                  disabled="disabled"
                  @change="getStateForRegdOffice(masterFormData.address.countryCode)"
                >
                  <option v-for="c in countryList" :key="c" :value="c.value">{{c.text}}</option>
                </select>
              </div>
              <div class="col-3">
                <div>State</div>
                <select
                  v-model="masterFormData.address.stateCode"
                  class="form-control"
                  :class="stateList.length > 0 ? '': 'disabled'"
                  @change="getCityForRegdOffice(masterFormData.address.stateCode)"
                >
                  <option v-for="s in stateList" :key="s" :value="s.value">{{s.text}}</option>
                </select>
              </div>
              <div class="col-3">
                <div>City</div>
                <select
                  v-model="masterFormData.address.cityCode"
                  class="form-control"
                  :class="cityList.length > 0 ? '': 'disabled'"
                >
                  <option v-for="c in cityList" :key="c" :value="c.value">{{c.text}}</option>
                </select>
              </div>
              <div class="col-2">
                <div>Zip Code</div>
                <input
                  v-model="masterFormData.address.zipCode"
                  class="form-control"
                  maxlength="6"
                  @keypress="isNumber($event, newMobile)"
                />
              </div>
              <div class="col-12">
                <FileUploader
                  class="text-left"
                  :id="'documentId'"
                  :heading="'Attach Address proof*'"
                  @fileInputChange="getAddressAttachment($event)"
                />
                <div class="col-10 mt-1 p-0 pt-1" v-if="masterFormData.address.documentId">
                  <ul style="list-style-type:disc;">
                    <li>
                      <a
                        @click="showAttachFile(masterFormData.address.documentId)"
                        href="#"
                      >{{getFileName(masterFormData.address.documentId)}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div style="font-size:14px;padding: 10px 5px;">
            {{financialDocumentNumber? ' Doc Number: '+financialDocumentNumber : ''}}
            <span
              style="padding: 20px 10px;"
              v-html="getFinStatus()"
            ></span>
          </div>
          <div
            v-if="financialDocumentStatus && (financialDocumentStatus == 'S' || financialDocumentStatus == 'R')"
            style="font-size: 14px;font-weight: normal;padding-bottom:13px;"
          >WorkFlow Remarks: {{financialWorkflowRemarks ? financialWorkflowRemarks:''}}</div>
          <div :class="isFinancial ? '': 'disableds'">
            <div style="font-weight: bold;">Statutory Details:</div>
            <div class="row">
              <div class="col-lg-6 col-md-6 col-12 item-c">
                CIN Number:
                <input
                  class="form-control"
                  type="text"
                  placeholder="CIN Number"
                  v-model="masterFormData.statutory.cin"
                />
              </div>
              <div class="col-lg-6 col-md-6 col-12 item-c">
                TAN Number:
                <input
                  class="form-control"
                  type="text"
                  placeholder="TAN Number"
                  v-model="masterFormData.statutory.tanNumber"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <FileUploader
                  class="text-left"
                  :id="'documentId'"
                  :heading="'Attach CIN document*'"
                  @fileInputChange="getCinAttachment($event)"
                />
                <div class="col-10 mt-1 p-0 pt-1" v-if="masterFormData.cinDocId">
                  <ul style="list-style-type:disc;">
                    <li>
                      <a
                        @click="showAttachFile(masterFormData.cinDocId)"
                        href="#"
                      >{{getFileName(masterFormData.cinDocId)}}</a>
                    </li>
                  </ul>
                </div>
              </div>
              <div class="col-6">
                <FileUploader
                  class="text-left"
                  :id="'documentId'"
                  :heading="'Attach TAN document*'"
                  @fileInputChange="getTanAttachment($event)"
                />
                <div class="col-10 mt-1 p-0 pt-1" v-if="masterFormData.tanDocId">
                  <ul style="list-style-type:disc;">
                    <li>
                      <a
                        @click="showAttachFile(masterFormData.tanDocId)"
                        href="#"
                      >{{getFileName(masterFormData.tanDocId)}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            <div style="font-weight: bold;">GST Details:</div>
            <div class="row">
              <div class="col-lg-12 col-md-12 col-12 item-c">
                <div class="row" v-for="(g,index) in masterFormData.gstDetails" :key="index">
                  <div class="col-lg-4 col-md-6 col-12">
                    GST Number:
                    <input
                      class="form-control disableds"
                      type="text"
                      placeholder="GST Number"
                      v-model="g.gstNumber"
                    />
                  </div>
                  <div class="col-lg-4 col-md-6 col-12">
                    <FileUploader
                      class="text-left"
                      :id="'documentId'"
                      :heading="'Attach Vendor Letter head request*'"
                      @fileInputChange="getGstAttachment($event,index)"
                    />
                    <div class="col-10 mt-1 p-0 pt-1" v-if="g.gstDocId">
                      <ul style="list-style-type:disc;">
                        <li>
                          <a
                            @click="showAttachFile(g.gstDocId)"
                            href="#"
                          >{{getFileName(g.gstDocId)}}</a>
                        </li>
                      </ul>
                    </div>
                  </div>
                  <div class="col-lg-4 col-md-6 col-12">
                    <div style="font-weight: ">Valid Status</div>
                    <table id="isGSTValid">
                      <tbody>
                        <tr>
                          <td>
                            <input
                              :id="'isGSTValid_'+index"
                              type="radio"
                              :name="'isGSTValid_'+index"
                              value="Y"
                              v-model="g.validStatus"
                            />
                            <label :for="'isGSTValid_'+index">Yes</label>
                          </td>
                          <td>
                            <input
                              :id="'isGSTValid_1'+index"
                              type="radio"
                              :name="'isGSTValid_1'+index"
                              value="N"
                              v-model="g.validStatus"
                            />
                            <label :for="'isGSTValid_1'+index">No</label>
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
            <div class="row">
              <div class="col-sm-12">
                <p style="font-size: 15px; font-weight: 700;">
                  MSME Details
                  <span style="color: red; font-weight: 700;">*</span>
                </p>
              </div>
            </div>
            <div class="row" style="margin-bottom:10px;">
              <div class="col-sm-12 md-radio md-radio-inline">
                <div style>
                  <b-form-group label>
                    <b-form-radio-group
                      v-model="masterFormData.statutory.isMsme"
                      @change="removeMsmeDetails()"
                      :options="[
          { text: 'Yes', value: 'Y' },
          { text: 'No', value: 'N' }        ]"
                    ></b-form-radio-group>
                  </b-form-group>
                </div>
                <table id="isMsmeContent1">
                  <tbody>
                    <tr valign="bottom">
                      <td
                        style="padding: 0px 20px 0px 0px;"
                        v-if="masterFormData.statutory.isMsme == 'Y'"
                      >
                        <label for="msmeNumber">MSME Type</label>
                        <select
                          name="msme"
                          id="msme"
                          class="form-control"
                          v-model="masterFormData.statutory.msmeType"
                        >
                          <option value>--Select--</option>
                          <option value="MICRO">Micro</option>
                          <option value="SMALL">Small</option>
                          <option value="MEDIUM">Medium</option>
                        </select>
                      </td>
                      <td
                        style="padding: 0px 20px 0px 5px;max-width: 160px;"
                        v-if="masterFormData.statutory.isMsme == 'Y'"
                      >
                        <label for="msmeNumber">MSME Number</label>
                        <input
                          id="msmeNumber"
                          type="text"
                          name="msmeNumber"
                          @keyup="restrictMsme()"
                          value
                          class="form-control"
                          v-model="masterFormData.statutory.msmedNumber"
                        />
                      </td>
                      <td
                        style="padding: 0px 20px 0px 5px;"
                        v-if="masterFormData.statutory.isMsme == 'Y'"
                      >
                        <label for="msmeCertFrom">MSME- Effective From</label>
                        <input
                          id="msmeCertFrom"
                          type="date"
                          name="msmeCertFrom"
                          value
                          class="form-control"
                          v-model="masterFormData.statutory.certificateEffectiveFrom"
                        />
                      </td>
                      <td style v-if="masterFormData.statutory.isMsme == 'Y'">
                        <label for="msmeCertUpto">MSME- Effective To</label>
                        <input
                          id="msmeCertUpto"
                          type="date"
                          name="msmeCertUpto"
                          value
                          class="form-control"
                          v-model="masterFormData.statutory.certificateEffectiveUpto"
                        />
                      </td>
                      <td
                        v-if="masterFormData.statutory.isMsme == 'Y'"
                        style="padding: 0px 20px 0px 25px;"
                      >
                        <div>
                          <FileUploader
                            :heading="'MSME Certificate'"
                            :isDeclaration="true"
                            @fileInputChange="getMsmeDocument($event,0,'msme')"
                          />
                          <ul
                            style="list-style-type:disc;"
                            v-if="masterFormData.statutory.msmeDocId"
                          >
                            <li>
                              <a
                                @click="showAttachFile(masterFormData.statutory.msmeDocId)"
                                href="#"
                                class="mt-n2"
                              >{{getFileName(masterFormData.statutory.msmeDocId)}}</a>
                            </li>
                          </ul>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
            <div style="font-weight: bold;">Financial Details:</div>
            <div class="row">
              <div class="col-lg-2 col-md-6 col-12 item-c">
                Financial Year:
                <input
                  class="form-control disableds"
                  type="text"
                  placeholder="Turn Over"
                  v-model="masterFormData.financialDetails.financeYearDisplay"
                />
              </div>
              <div class="col-lg-5 col-md-6 col-12 item-c">
                Last Year Turn Over:
                <input
                  class="form-control"
                  type="text"
                  placeholder="Turn Over"
                  v-model="masterFormData.financialDetails.revenue"
                />
              </div>
              <div class="col-lg-5 col-md-6 col-12">
                <FileUploader
                  class="text-left"
                  :id="'documentId'"
                  :heading="'Attach ITR or Balance Sheet*'"
                  @fileInputChange="getFinancialDocument($event)"
                />
                <div
                  class="col-10 mt-1 p-0 pt-1"
                  v-if="masterFormData.financialDetails.financeDocId"
                >
                  <ul style="list-style-type:disc;">
                    <li>
                      <a
                        @click="showAttachFile(masterFormData.financialDetails.financeDocId)"
                        href="#"
                      >{{getFileName(masterFormData.financialDetails.financeDocId)}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
            <div>Bank Details:</div>
            <div class="row">
              <div class="col-6 mt-2">
                <b-form-group class="source-sans-pro text-left" label="Account Category">
                  <w-dropdown
                    class="width-control-small"
                    :options="accountCategories"
                    @dropdownChange="getAccountCategories($event)"
                    :selected="masterFormData.bankDetails.accountCategoryCode"
                  />
                </b-form-group>
              </div>
              <div class="col-6 mt-2">
                <b-form-group class="source-sans-pro text-left" label="Account Type">
                  <w-dropdown
                    class="width-control-small"
                    :options="accountTypeCategories"
                    @dropdownChange="getAccountTypeCategories($event)"
                    :selected="masterFormData.bankDetails.accountTypeCode"
                  />
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <b-form-group class="source-sans-pro text-left" label="Payment Mode">
                  <w-dropdown
                    class="width-control-small"
                    :options="bankPaymentModes"
                    @dropdownChange="getBankPaymentMode($event)"
                    :selected="masterFormData.bankDetails.paymentModeCode"
                  />
                </b-form-group>
              </div>
              <div class="col-6">
                <w-text-input
                  class="text-left"
                  :labelName="$t('Payment in favour of')"
                  @textInputChange="getPaymentInFavour($event)"
                  validation="required|regex_company_name"
                  :defaultValue="masterFormData.bankDetails.paymentInfavourOf"
                  :maxCharacter="'100'"
                />
              </div>
            </div>
            <div class="row">
              <div class="col-6">
                <b-form-group class="source-sans-pro text-left" label="Bank Name">
                  <w-dropdown
                    class="width-control-small"
                    :options="bankNameList"
                    @dropdownChange="getBankName($event)"
                    :selected="masterFormData.bankDetails.bankCode"
                  />
                </b-form-group>
              </div>
              <div class="col-6" v-if="!$root.isInternational">
                <b-form-group class="source-sans-pro field-headings">
                  <w-text-input
                    class="text-left"
                    :labelName="$t('IFSC Code')"
                    @textInputChange="getBankBranchIFSCCode($event)"
                    validation="required|regex_ifsc"
                    :defaultValue="masterFormData.bankDetails.ifscCode"
                    :inputAdditions="'mobile'"
                    :maxDigits="'7'"
                    :isdCode="ifscShortDesc"
                    :disabled="!ifscShortDesc"
                  />
                  <p
                    v-if="ifscErrorArray"
                    class="ifsc-invalid lato-regular"
                  >{{$t('IFSC Code is Invalid')}}</p>
                </b-form-group>
              </div>

              <div class="col-6" v-if="$root.isInternational">
                <b-form-group class="source-sans-pro field-headings text-left">
                  <w-text-input
                    :labelName="$t('Swift Code')"
                    @textInputChange="getBankSwiftBicCode($event,i)"
                    validation="required|min:8|max:11|regex_swift"
                    :defaultValue="masterFormData.bankDetails.swiftBicCode"
                    :inputAdditions="'mobile'"
                    :maxDigits="'11'"
                  />
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-6" v-if="$root.isInternational">
                <b-form-group class="source-sans-pro field-headings text-left">
                  <w-text-input
                    :labelName="$t('IBAN Code')"
                    @textInputChange="getBankIbanNumber($event,i)"
                    validation="required|regex_alpha_numeric|max:34|min:5"
                    :defaultValue="masterFormData.bankDetails.ibanNumber"
                    :inputAdditions="'mobile'"
                    :maxDigits="'34'"
                  />
                </b-form-group>
              </div>
              <div class="col-6">
                <b-form-group class="source-sans-pro field-headings">
                  <w-text-input
                    class
                    :labelName="$t('Account Number')"
                    @textInputChange="getBankAccountNumber($event)"
                    validation="required|min:3|max:25|regex_account_number"
                    :defaultValue="masterFormData.bankDetails.accountNumber"
                    :inputAdditions="'mobile'"
                  />
                  <p
                    class="mt-n2 font-weight-bold text-danger lato-regular"
                    v-if="duplicateAccountNumber == true"
                  >Account Number is already exists</p>
                </b-form-group>
              </div>

              <div class="col-6">
                <b-form-group
                  class="source-sans-pro field-headings"
                  :class="$root.isInternational ? '': ''"
                >
                  <w-text-input
                    :labelName="$t('Payment Confirmation Mail Id')"
                    @textInputChange="getPaymentRefMailId($event)"
                    :validation="'required|email'"
                    :defaultValue="masterFormData.bankDetails.paymentRefMailId"
                    :maxCharacter="'100'"
                    :type="'text'"
                  />
                </b-form-group>
              </div>
            </div>
            <div class="row">
              <div class="col-8 mt-2">
                <FileUploader
                  class="text-left"
                  :id="'documentId'"
                  :heading="'Attach Cancelled cheque or Relevant documents/proofs *'"
                  @fileInputChange="getBankDocument($event)"
                />
                <div class="col-10 mt-1 p-0 pt-1" v-if="masterFormData.bankDetails.documentId">
                  <ul style="list-style-type:disc;">
                    <li>
                      <a
                        @click="showAttachFile(masterFormData.bankDetails.documentId)"
                        href="#"
                      >{{getFileName(masterFormData.bankDetails.documentId)}}</a>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div
      style="margin-top:20px;background:aliceblue; padding: 15px 10px; border-radius:10px;"
      v-if="isAllowed"
    >
      <input
        id="rdIAccept_0"
        type="checkbox"
        name="rdIAccept"
        value="Y"
        style="width: 26px;transform: scale(1.3);"
        v-model="submitEnable"
      />
      <label for="rdIAccept_0">I acknowledge all the details provided above are true to my knowledge</label>

      <div style="text-align:center;">
        <button
          :class="submitEnable ? '' : 'disableds'"
          class="btn btn-primary"
          style="font-weight: bold;padding: 5px 10px;cursor: pointer;"
          @click="submitReKyc()"
        >Submit</button>
      </div>
    </div>
    <confirmationModal
      v-if="triggerConfirmModal"
      :trigger="triggerConfirmModal"
      :text="lastResponseConfirm"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      @eventOk="callAfterConfirmModal()"
      @eventCancel="closeConfirmModal()"
    />
    <w-modal
      :trigger="triggerModal"
      :text="lastResponse"
      :title="modalTitle"
      :centered="true"
      :dontCloseWhenClickedOutside="true"
      :dontCloseWhenEscapePressed="true"
      :dontShowCloseIcon="true"
      :modalbuttonStyle="true"
      :showAlert="alertModal"
      :showSuccess="successModal"
      @eventClose="closeTriggerdModal()"
    />
  </div>
</template>
<script>
import DropDown from "../widgets/DropDown";
var ifsc = require("ifsc");
import TextInput from "../widgets/TextInput";
import FileUploader from "../widgets/FileUploader";
import loadingSpinner from "../widgets/LoadingSpinner";
import { PartnerService } from "../services/partnerService";
const partnerService = new PartnerService();

import { OnBoardingServices } from "../services/onBoardingService";
import confirmationModal from "../widgets/confirmationModal";
import Modal from "../widgets/newModalWidget";
const OnBoardingService = new OnBoardingServices();
export default {
  components: {
    "w-text-input": TextInput,
    "w-dropdown": DropDown,
    "w-loadingSpinner": loadingSpinner,
    "w-modal": Modal,
    FileUploader,
    confirmationModal
  },
  created() {
    var self = this;
    this.isIE = window.document.documentMode;
    this.getKYCDetails();
    this.getBanksMasters();
    this.getDocumentSubmission();
  },
  data() {
    return {
      isAllowed: true,
      isTechnical: true,
      isFinancial: true,
      technicalWorkflowRemarks: "",
      financialWorkflowRemarks: "",
      technicalDocumentStatus: "",
      financialDocumentStatus: "",
      technicalDocumentNumber: "",
      financialDocumentNumber: "",
      triggerModal: false,
      successModal: false,
      lastResponse: "",
      alertModal: false,
      lastResponseConfirm: "",
      triggerConfirmModal: false,
      countryList: [],
      stateList: [],
      cityList: [],
      isEdit: false,
      isIE: true,
      bankPaymentModes: [],
      accountCategories: [],
      accountTypeCategories: [],
      bankNameList: [],
      ifscCodeList: [],
      virginMasterFormData: null,
      masterFormData: {
        idCardDocId: "",
        partnerName: "",
        idCardValue: "",
        idCardCode: null,
        mobileNumber: "",
        isdCode: "",
        email: "",
        cinDocId: "",
        cinSiteUrl: "",
        tanDocId: "",
        tanSiteUrl: "",
        address: {
          streetAddress: "",
          country: "",
          state: "",
          city: "",
          zipCode: "",
          addressType: "",
          countryCode: null,
          stateCode: null,
          cityCode: null,
          addressTypeCode: null,
          slno: null,
          sezTag: "",
          documentId: "",
          siteUrl: "Partner",
          gstNumber: null
        },
        statutory: {
          id: {
            companyCode: null,
            partnerId: null,
            categoryCode: null
          },
          cin: null,
          llpin: null,
          frn: null,
          sern: null,
          isMsme: "",
          gstin: null,
          msmedNumber: "",
          msmeType: null,
          tanNumber: "",
          aadhaarNumber: null,
          iec: null,
          din: null,
          pfNumber: null,
          pfBranchId: null,
          esiNumber: "",
          esiBranchId: null,
          yearIncorporation: "",
          placeIncorporation: "",
          ownershipType: null,
          yearCommencementMfg: null,
          factoryInspectorCfNo: null,
          shopEstablishmentCfNo: null,
          lntEmpInOrgn: "",
          partnerWithLnt: "",
          active: "",
          insertedBy: null,
          insertedOn: "",
          updatedBy: null,
          updatedOn: "",
          gstinDocumentId: "",
          tanDocumentId: null,
          aadhaarDocumentId: null,
          isEinvoiceApplicable: "",
          isTCSApplicable: "",
          pfEmployeeCount: null,
          esiRemarks: null,
          certificateEffectiveFrom: null,
          certificateEffectiveUpto: null,
          enterpriseSectorCode: null,
          enterpriseCategoryCode: null,
          investedAmount: null,
          gstinValidTag: "",
          vatNumber: null,
          vatDocumentId: null,
          vatSiteUrl: null,
          msmeDocId: null,
          msmeSiteUrl: null
        },
        gstDetails: [
          {
            validStatus: null,
            gstNumber: null,
            gstDocId: null,
            gstSiteUrl: null,
            slNo: 0
          }
        ],
        financialDetails: null,
        bankDetails: {
          slNo: 1,
          statusCode: 1,
          accountCategory: "",
          accountCategoryCode: null,
          accountNumber: "",
          paymentInfavourOf: "",
          accountType: "",
          accountTypeCode: null,
          bankName: null,
          bankCode: null,
          ifscCode: "",
          paymentMode: "",
          paymentModeCode: null,
          documentNo: null,
          remarks: null,
          documentId: null,
          siteUrl: null,
          swiftBicCode: null,
          ibanNumber: null,
          paymentRefMailId: "",
          updatedBy: null,
          updatedOn: "",
          updatedByCommunityCode: null
        }
      },
      submitEnable: false
    };
  },
  props: [
    "text",
    "title",
    "centered",
    "dontCloseWhenClickedOutside",
    "dontCloseWhenEscapePressed",
    "dontShowCloseIcon",
    "modalbuttonStyle",
    "showAlert",
    "showSuccess",
    "extraMessage",
    "isBoldText",
    "needResendEmail",
    "browserMessage",
    "modalSize",
    "sscNotification",
    "itrcutoffmonth",
    "idCardValue",
    "showSkipDeclaration",
    "dashboardData",
    "companyCode",
    "partnerId",
    "isInternational"
  ],
  methods: {
    getTechStatus() {
      var color = "";
      var value = "";
      if (this.technicalDocumentStatus == "C") {
        value = "Approval in progress";
        color = "orange";
      }
      if (this.technicalDocumentStatus == "N") {
        value = "Draft";
        color = "#f5f520";
      }
      if (this.technicalDocumentStatus == "A") {
        value = "Approved";
        color = "green";
      }
      if (this.technicalDocumentStatus == "S") {
        value = "Sentback";
        color = "blue";
      }
      if (this.technicalDocumentStatus == "R") {
        value = "Rejected";
        color = "red";
      }

      return `<span style="color:${color}">${value}</span>`;
    },
    getFinStatus() {
      var color = "";
      var value = "";
      if (this.financialDocumentStatus == "C") {
        value = "Approval in progress";
        color = "orange";
      }
      if (this.financialDocumentStatus == "N") {
        value = "Draft";
        color = "#f5f520";
      }
      if (this.financialDocumentStatus == "A") {
        value = "Approved";
        color = "green";
      }
      if (this.financialDocumentStatus == "S") {
        value = "Sentback";
        color = "blue";
      }
      if (this.financialDocumentStatus == "R") {
        value = "Rejected";
        color = "red";
      }

      return `<span style="color:${color}">${value}</span>`;
    },
    removeMsmeDetails() {
      this.masterFormData.statutory.isMsme = "N";
      this.masterFormData.statutory.msmedNumber = null;
      this.masterFormData.statutory.msmeType = null;
      this.masterFormData.statutory.certificateEffectiveFrom = null;
      this.masterFormData.statutory.certificateEffectiveUpto = null;
      this.masterFormData.statutory.msmeDocId = null;
      this.masterFormData.statutory.msmeSiteUrl = null;
    },
    getStateForRegdOffice(countryCode) {
      this.stateList = [];
      OnBoardingService.getStatesForRegisteredOffice(countryCode).then(resp => {
        resp.response.forEach(state => {
          this.stateList.push({
            text: state.longDescr,
            value: state.stateCode
          });
        });
      });
    },
    getCityForRegdOffice(stateCode) {
      this.cityList = [];
      OnBoardingService.getCityForRegisteredOffice(stateCode).then(resp => {
        resp.response.forEach(city => {
          this.cityList.push({
            text: city.cityName,
            value: city.cityCode
          });
        });
      });
    },
    getIdCardAttachment(event) {
      this.loading = true;
      this.formChanged = true;
      console.log(event[0]);
      let data = new FormData();
      let file = event[0];
      console.log(file);
      // data.append("name", "my-file");
      data.append("file", file);
      OnBoardingService.uploadAttachments(data).then(resp => {
        this.loading = false;
        if (resp) {
          this.masterFormData.idCardDocId = resp.UniqueID;
          this.masterFormData.idCardSiteUrl = resp.SiteUrl;
        }
      });
    },
    getLetterHeadAttachment(event) {
      this.loading = true;
      this.formChanged = true;
      console.log(event[0]);
      let data = new FormData();
      let file = event[0];
      console.log(file);
      // data.append("name", "my-file");
      data.append("file", file);
      OnBoardingService.uploadAttachments(data).then(resp => {
        this.loading = false;
        if (resp) {
          this.masterFormData.letterHeadDocId = resp.UniqueID;
          this.masterFormData.letterHeadSiteurl = resp.SiteUrl;
        }
      });
    },
    getAddressAttachment(event) {
      this.loading = true;
      this.formChanged = true;
      console.log(event[0]);
      let data = new FormData();
      let file = event[0];
      console.log(file);
      // data.append("name", "my-file");
      data.append("file", file);
      OnBoardingService.uploadAttachments(data).then(resp => {
        this.loading = false;
        if (resp) {
          this.masterFormData.address.documentId = resp.UniqueID;
          this.masterFormData.address.siteUrl = resp.SiteUrl;
        }
      });
    },
    getCinAttachment(event) {
      this.loading = true;
      this.formChanged = true;
      console.log(event[0]);
      let data = new FormData();
      let file = event[0];
      console.log(file);
      // data.append("name", "my-file");
      data.append("file", file);
      OnBoardingService.uploadAttachments(data).then(resp => {
        this.loading = false;
        if (resp) {
          this.masterFormData.cinDocId = resp.UniqueID;
          this.masterFormData.cinSiteUrl = resp.SiteUrl;
        }
      });
    },
    getTanAttachment(event) {
      this.loading = true;
      this.formChanged = true;
      console.log(event[0]);
      let data = new FormData();
      let file = event[0];
      console.log(file);
      // data.append("name", "my-file");
      data.append("file", file);
      OnBoardingService.uploadAttachments(data).then(resp => {
        this.loading = false;
        if (resp) {
          this.masterFormData.tanDocId = resp.UniqueID;
          this.masterFormData.tanSiteUrl = resp.SiteUrl;
        }
      });
    },
    getGstAttachment(event, i) {
      this.loading = true;
      this.formChanged = true;
      console.log(event[0]);
      let data = new FormData();
      let file = event[0];
      console.log(file);
      // data.append("name", "my-file");
      data.append("file", file);
      OnBoardingService.uploadAttachments(data).then(resp => {
        this.loading = false;
        if (resp) {
          this.masterFormData.gstDetails[i].gstDocId = resp.UniqueID;
          this.masterFormData.gstDetails[i].gstSiteUrl = resp.SiteUrl;
        }
      });
    },
    getMsmeDocument(event) {
      this.loading = true;
      this.formChanged = true;
      console.log(event[0]);
      let data = new FormData();
      let file = event[0];
      console.log(file);
      // data.append("name", "my-file");
      data.append("file", file);
      OnBoardingService.uploadAttachments(data).then(resp => {
        this.loading = false;
        if (resp) {
          this.masterFormData.statutory.msmeDocId = resp.UniqueID;
          this.masterFormData.statutory.msmeSiteUrl = resp.SiteUrl;
        }
      });
    },
    getFinancialDocument(event) {
      this.loading = true;
      this.formChanged = true;
      console.log(event[0]);
      let data = new FormData();
      let file = event[0];
      console.log(file);
      // data.append("name", "my-file");
      data.append("file", file);
      OnBoardingService.uploadAttachments(data).then(resp => {
        this.loading = false;
        if (resp) {
          this.masterFormData.financialDetails.financeDocId = resp.UniqueID;
          this.masterFormData.financialDetails.financeSiteUrl = resp.SiteUrl;
        }
      });
    },
    getBankDocument(event) {
      this.loading = true;
      this.formChanged = true;
      console.log(event[0]);
      let data = new FormData();
      let file = event[0];
      console.log(file);
      // data.append("name", "my-file");
      data.append("file", file);
      OnBoardingService.uploadAttachments(data).then(resp => {
        this.loading = false;
        if (resp) {
          this.masterFormData.bankDetails.documentId = resp.UniqueID;
          this.masterFormData.bankDetails.siteUrl = resp.SiteUrl;
        }
      });
    },
    submitReKyc() {
      this.triggerConfirmModal = true;
      this.lastResponseConfirm = "Are you sure to submit?";
    },
    closeTriggerdModal() {
      this.triggerModal = false;
      this.alertModal = false;
      this.successModal = false;
      this.clearFeedbackFields();
      location.reload();
    },
    callAfterConfirmModal() {
      this.triggerConfirmModal = false;
      partnerService
        .submitKycDetails(this.masterFormData)
        .then(res => {
          if (res.status == "FAILURE") {
            this.triggerModal = true;
            this.alertModal = true;
            this.lastResponse = res.failureMessage;
          } else if (res.status == "SUCCESS") {
            this.triggerModal = true;
            this.successModal = true;
            this.lastResponse = res.response;
            this.getDocumentSubmission();
          }
        })
        .catch();
    },
    closeConfirmModal() {
      this.triggerConfirmModal = false;
    },
    getAttachment(event, type) {
      this.loading = true;
      this.formChanged = true;
      console.log(event[0]);
      let data = new FormData();
      let file = event[0];
      console.log(file);
      // data.append("name", "my-file");
      data.append("file", file);
      OnBoardingService.uploadAttachments(data).then(resp => {
        this.loading = false;
        if (resp && type == "pan") {
          //this.masterFormData.documentId = resp.UniqueID;
          //this.bankForm.siteUrl = resp.SiteUrl;
        }
      });
    },
    showAttachFile(event) {
      this.loading = true;
      OnBoardingService.downLoadDocument(event)
        .then(res => {
          this.loading = false;
        })
        .catch(e => {
          window.alert("Something went wrong! try again later");
          this.loading = false;
        });
    },
    getFileName(fileName) {
      var fileNameFinal = "";
      fileNameFinal = fileName.split(/_(.+)/)[1];
      return fileNameFinal;
    },
    eventOk(event) {
      this.$emit("DeclarationOk", event);
    },
    closeEmpanelModal(event) {
      this.$emit("eventKYCClose", event);
    },
    getKYCDetails() {
      partnerService
        .getKycDetails(this.companyCode, this.partnerId)
        .then(resp => {
          this.masterFormData = resp.response;
          this.virginMasterFormData = JSON.parse(JSON.stringify(resp.response));
          this.getCountriesForRegdOffice();
        });
    },
    getDocumentSubmission() {
      partnerService.submittedDocumentDetails(this.companyCode).then(resp => {
        this.technicalWorkflowRemarks = resp.response.techRemarks;
        this.financialWorkflowRemarks = resp.response.finRemarks;
        this.technicalDocumentStatus = resp.response.techStatus;
        this.financialDocumentStatus = resp.response.finStatus;
        this.technicalDocumentNumber = resp.response.techDocumentNumber;
        this.financialDocumentNumber = resp.response.finDocumentNumber;
        if (
          this.technicalDocumentStatus == "C" ||
          this.technicalDocumentStatus == "A"
        ) {
          this.isTechnical = false;
          this.isEdit = true;
        }
        if (
          this.financialDocumentStatus == "C" ||
          this.financialDocumentStatus == "A"
        ) {
          this.isFinancial = false;
          this.isEdit = true;
        }
        if (
          this.financialDocumentStatus == "C" ||
          this.financialDocumentStatus == "A" ||
          this.financialDocumentStatus == "S" ||
          this.financialDocumentStatus == "R"
        ) {
          this.isAllowed = false;
        }
      });
    },
    getCountriesForRegdOffice() {
      this.countryList = [];
      var self = this;
      OnBoardingService.getCountriesForRegdOffice().then(resp => {
        resp.response.forEach(country => {
          this.countryList.push({
            text: country.longDesc,
            value: country.countryCode
          });
        });

        this.getStatesForRegdOffice();
      });
    },
    getStatesForRegdOffice() {
      this.stateList = [];
      OnBoardingService.getStatesForRegisteredOffice(
        this.masterFormData.address.countryCode
      ).then(resp => {
        resp.response.forEach(state => {
          this.stateList.push({
            text: state.longDescr,
            value: state.stateCode
          });
        });
      });

      this.getCityForRegdOffice(this.masterFormData.address.stateCode);
    },
    getCityForRegdOffice(stateCode) {
      this.cityList = [];
      OnBoardingService.getCityForRegisteredOffice(stateCode).then(resp => {
        resp.response.forEach(city => {
          this.cityList.push({
            text: city.cityName,
            value: city.cityCode
          });
        });
      });
    },
    getBanksMasters() {
      OnBoardingService.getBankPaymentMode().then(resp => {
        resp.response.forEach(modes => {
          this.bankPaymentModes.push({
            text: modes.shortDesc,
            value: modes.paymentModeCode
          });
        });
        OnBoardingService.getAccountType().then(resp => {
          resp.response.forEach(bank => {
            this.accountTypeCategories.push({
              text: bank.accTypeLongDesc,
              value: bank.accTypeCode
            });
          });
          OnBoardingService.getBankAccountCategory().then(resp => {
            resp.response.forEach(bankType => {
              this.accountCategories.push({
                text: bankType.accCategoryLongDesc,
                value: bankType.accCategoryCode
              });
            });
            OnBoardingService.getBankName().then(resp => {
              resp.response.forEach(bank => {
                this.bankNameList.push({
                  text: bank.longDesc,
                  value: bank.code
                });
                this.ifscCodeList.push({
                  bankCode: bank.code,
                  ifscCode: bank.ifscShortCode
                });
              });
            });
          });
        });
      });
    }
  }
};
</script>

<style>
.ssc-notification {
  width: 100% !important;
  max-width: 100% !important;
}

.ssc-notification-90 {
  width: 90% !important;
  max-width: 90% !important;
}

.ssc-notification .modal-dialog {
  width: 100% !important;
  max-width: 100% !important;
}
.Modal-head-text {
  color: white;
  font-size: 13px;
  float: left;
}
.approve-tick-image {
  /* width: 23%; */
  height: 8vh !important;
  display: block;
  margin-left: auto !important;
  margin-right: auto !important;
  /* width: 50%; */
  margin: auto !important;
}
.Approver-Success-text {
  text-align: center;
  font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  font-weight: 600;
  color: #333333;
}
.Approver-bold-Success-text {
  text-align: center;
  /* font-family: "Source Sans Pro", sans-serif;
  font-size: 15px;
  font-weight: 300;
  color: #333333; */
}

.document-number-text {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 13px;
  font-weight: 500;
  text-align: left;
  color: var(--brownish-grey);
}

.modal-horizontal-line {
  margin-left: 0px;
  margin-right: 0px;
}
.modal-content {
  width: 80%;
}
.empanel-modal-close {
  padding: 8px !important;
  background-image: linear-gradient(to bottom, #1d76ae, #055396);
  border: 0.1px;
}
.browser-modal-close {
  background: rgb(252, 255, 80);
}
.Document-Number {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 12px;
  font-weight: 600;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.25;
  letter-spacing: normal;
  color: #777777;
}
.button-class {
  font-family: "Source Sans Pro", sans-serif;
  font-size: 14px;
  font-weight: normal;
  font-style: normal;
  font-stretch: normal;
  line-height: 1.29;
  letter-spacing: normal;
  text-align: center;
  color: white;
  border-radius: 2px;
  background-color: #1579ab;
}
.modal-body {
  padding: 0;
}
.modal-close-button {
  border: solid 1px #707070;
  color: rgba(0, 0, 0, 0.85);
  border-radius: 50%;
  background-color: rgb(255, 255, 255) !important;
  margin: 0.5px 0px 0px 5px !important;
  width: 18px;
}
.browser-modal-text {
  font-size: 22px !important;
}

.item-c {
  padding: 5px 10px 20px 10px;
}

#kyccontainer input[type="radio"] {
  transform: scale(1.3) !important;
  margin: 0px 7px;
}
.disableds {
  user-select: none;
  -webkit-user-select: none;
  -moz-user-select: none;
  opacity: 0.6;
  pointer-events: none;
  cursor: not-allowed;
}
.cur {
  cursor: not-allowed;
}
.prefix {
  position: absolute;
  left: 18px;
  top: 32px;
  background: aliceblue;
}
.has-prefix {
  padding-left: 50px;
}
</style>